import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  SiFacebook,
  SiInstagram,
  SiTiktok,
  SiLinkedin,
  SiPinterest,
  SiYoutube,
} from "react-icons/si";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { userById } from "../actions/userById";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import ReactPlayer from "react-player";
import {
  TikTokEmbed,
  InstagramEmbed,
  FacebookEmbed,
  YouTubeEmbed,
  XEmbed,
  PinterestEmbed,
  LinkedInEmbed,
} from "react-social-media-embed";
import { propertyByUser } from "../actions/propertyByUser";

const User = () => {
  const { id } = useParams();
  const [poster, setPoster] = useState(null);
  const [properties, setProperties] = useState([]);
  const [propertiesLoading, setPropertiesLoading] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    userById(id, { setPoster });
  }, [id]);

  useEffect(() => {
    if (!id) return;
    let active = true;
    const load = async () => {
      setPropertiesLoading(true);
await propertyByUser(
        {
          setProperties: (data) => {
            if (!active) return;
if (data && data.length > 0) {
}
            setProperties(Array.isArray(data) ? data : []);
          },
        },
        id,
      );
      if (active) setPropertiesLoading(false);
    };
    load();
    return () => {
      active = false;
    };
  }, [id]);

  const normalizeSocialUrl = (url) => {
    if (!url) return "";
    let trimmed = url.trim();
    if (!/^https?:\/\//i.test(trimmed)) trimmed = `https://${trimmed}`;
    return trimmed;
  };

  const getVideoEmbedData = (url) => {
    const normalized = normalizeSocialUrl(url);
    if (!normalized) return { provider: null, embedUrl: "" };
    const lower = normalized.toLowerCase();
    if (lower.includes("tiktok.com"))
      return { provider: "tiktok", embedUrl: normalized };
    const instaMatch = normalized.match(
      /instagram\.com\/(p|reel|tv)\/([^/?#]+)/i,
    );
    if (instaMatch) return { provider: "instagram", embedUrl: normalized };
    if (lower.includes("instagram.com"))
      return { provider: "instagram", embedUrl: normalized };
    if (lower.includes("facebook.com") || lower.includes("fb.watch"))
      return { provider: "facebook", embedUrl: normalized };
    if (lower.includes("linkedin.com"))
      return { provider: "linkedin", embedUrl: normalized };
    if (lower.includes("pinterest.com"))
      return { provider: "pinterest", embedUrl: normalized };
    if (lower.includes("x.com") || lower.includes("twitter.com"))
      return { provider: "x", embedUrl: normalized };
    if (
      lower.includes("youtube.com/watch") ||
      lower.includes("youtu.be") ||
      lower.includes("youtube.com/shorts")
    )
      return { provider: "youtube", embedUrl: normalized };
    return { provider: "default", embedUrl: normalized };
  };

  const renderVideoEmbed = (url) => {
    const { provider, embedUrl } = getVideoEmbedData(url);
    if (!embedUrl) return null;
    return (
      <div className="flex justify-center py-4">
        {provider === "tiktok" && <TikTokEmbed url={embedUrl} />}
        {provider === "instagram" && <InstagramEmbed url={embedUrl} />}
        {provider === "facebook" && <FacebookEmbed url={embedUrl} />}
        {provider === "youtube" && <YouTubeEmbed url={embedUrl} />}
        {provider === "linkedin" && <LinkedInEmbed url={embedUrl} />}
        {provider === "pinterest" && <PinterestEmbed url={embedUrl} />}
        {provider === "x" && <XEmbed url={embedUrl} />}
      </div>
    );
  };

  const allVideos = [
    { url: poster?.video, number: 1 },
    { url: poster?.video2, number: 2 },
    { url: poster?.video3, number: 3 },
    { url: poster?.video4, number: 4 },
  ].filter((v) => v.url);

  const formatPrice = (value) => {
    if (!value) return "Price not set";
    const price = Number(value);
    if (!Number.isFinite(price)) return "Price not set";
    return `$${price.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
  };

  const getPropertyImage = (mediaUrl) => {
    if (!mediaUrl) return null;
    const first = mediaUrl.split(",")[0];
    return first ? cloudinaryUrl(first) : null;
  };

  return (
    <>
      <div className="min-h-screen bg-white py-8 sm:py-16 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 gap-6 lg:grid-cols-[280px_1fr]">
          <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 flex flex-col gap-6">
            <div className="relative w-36 h-36 sm:w-48 sm:h-48 mx-auto">
              <div className="h-full w-full rounded-2xl overflow-hidden bg-slate-100 border border-slate-200 shadow-inner">
                {poster?.picture_url ? (
                  <img
                    className="h-full w-full object-cover"
                    src={cloudinaryUrl(poster?.picture_url)}
                    alt="profile"
                  />
                ) : (
                  <div className="flex h-full items-center justify-center text-slate-400 font-semibold text-sm">
                    Add a photo
                  </div>
                )}
              </div>
            </div>

            {poster?.class_type !== "N/A" &&
              poster?.class_type !== "Consumer" &&
              poster?.class_type !== "Builder" && (
                <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                  <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                    Brokerage
                  </div>
                  <table className="w-full text-left text-xs">
                    <tbody>
                      <tr>
                        <th className="pr-2 font-semibold">Name</th>
                        <td>{poster?.brokerage_name || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">License</th>
                        <td>{poster?.brokerage_number || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Broker</th>
                        <td>{poster?.broker_name || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Broker License</th>
                        <td>{poster?.broker_number || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Phone</th>
                        <td>
                          {poster?.brokerage_phone ? (
                            <a
                              href={`tel:${String(
                                poster.brokerage_phone,
                              ).replace(/[^+\d]/g, "")}`}
                            >
                              {poster.brokerage_phone}
                            </a>
                          ) : (
                            "Not set"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Email</th>
                        <td>
                          {poster?.brokerage_email ? (
                            <a href={`mailto:${poster.brokerage_email}`}>
                              {poster.brokerage_email}
                            </a>
                          ) : (
                            "Not set"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

            <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
              <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                Keys
              </div>
              <div className="text-slate-800 text-lg font-semibold">
                {typeof poster?.key_balance !== "undefined"
                  ? Number(poster.key_balance || 0).toLocaleString()
                  : typeof poster?.keys !== "undefined"
                    ? Number(poster.keys || 0).toLocaleString()
                    : "0"}
              </div>
            </div>

            {/* NEW: Realtor Sub-Type Information */}
            {poster?.class_type === "Realtor" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Realtor Status
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    <tr>
                      <th className="pr-2 font-semibold">NAR Member</th>
                      <td>{poster?.is_realtor ? "Yes" : "No"}</td>
                    </tr>
                    {poster?.is_realtor === true && (
                      <tr>
                        <th className="pr-2 font-semibold">Broker</th>
                        <td>{poster?.is_broker ? "Yes" : "No"}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Expanded Builder Information */}
            {poster?.class_type === "Builder" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Builder Information
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {poster?.builder_number && (
                      <tr>
                        <th className="pr-2 font-semibold">Builder #</th>
                        <td>{poster.builder_number}</td>
                      </tr>
                    )}
                    {poster?.builder_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Email</th>
                        <td>
                          <a
                            href={`mailto:${poster.builder_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {poster.builder_email}
                          </a>
                        </td>
                      </tr>
                    )}
                    {poster?.builder_supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{poster.builder_supervisor_name}</td>
                      </tr>
                    )}
                    {poster?.builder_supervisor_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor Email</th>
                        <td>
                          <a
                            href={`mailto:${poster.builder_supervisor_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {poster.builder_supervisor_email}
                          </a>
                        </td>
                      </tr>
                    )}
                    {poster?.builder_company_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Company</th>
                        <td>{poster.builder_company_name}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Title Company Information */}
            {poster?.class_type === "Title Company" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Title Company Details
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {poster?.title_company_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Company Name</th>
                        <td>{poster.title_company_name}</td>
                      </tr>
                    )}
                    {poster?.title_company_address && (
                      <tr>
                        <th className="pr-2 font-semibold">Address</th>
                        <td>{poster.title_company_address}</td>
                      </tr>
                    )}
                    {poster?.title_company_phone && (
                      <tr>
                        <th className="pr-2 font-semibold">Phone</th>
                        <td>
                          <a
                            href={`tel:${String(poster.title_company_phone).replace(/[^+\d]/g, "")}`}
                            className="text-blue-600 hover:underline"
                          >
                            {poster.title_company_phone}
                          </a>
                        </td>
                      </tr>
                    )}
                    {poster?.title_company_supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{poster.title_company_supervisor_name}</td>
                      </tr>
                    )}
                    {poster?.title_company_supervisor_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor Email</th>
                        <td>
                          <a
                            href={`mailto:${poster.title_company_supervisor_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {poster.title_company_supervisor_email}
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Lender Information */}
            {poster?.class_type === "Lender" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Lender Credentials
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {poster?.company_license_number && (
                      <tr>
                        <th className="pr-2 font-semibold">
                          Company License #
                        </th>
                        <td>{poster.company_license_number}</td>
                      </tr>
                    )}
                    {poster?.supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{poster.supervisor_name}</td>
                      </tr>
                    )}
                    {poster?.supervisor_license_number && (
                      <tr>
                        <th className="pr-2 font-semibold">
                          Supervisor License #
                        </th>
                        <td>{poster.supervisor_license_number}</td>
                      </tr>
                    )}
                    {poster?.branch_address && (
                      <tr>
                        <th className="pr-2 font-semibold">Branch Address</th>
                        <td>{poster.branch_address}</td>
                      </tr>
                    )}
                    {poster?.branch_phone && (
                      <tr>
                        <th className="pr-2 font-semibold">Branch Phone</th>
                        <td>
                          <a
                            href={`tel:${String(poster.branch_phone).replace(/[^+\d]/g, "")}`}
                            className="text-blue-600 hover:underline"
                          >
                            {poster.branch_phone}
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <div className="space-y-4">
              <h2 className="text-lg font-bold text-slate-900">Contact</h2>
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <span className="text-slate-600 font-medium min-w-fit">
                    Phone:
                  </span>
                  <span className="text-slate-800 break-all">
                    {poster?.phone_number ? (
                      <a
                        href={`tel:${String(poster.phone_number).replace(
                          /[^+\d]/g,
                          "",
                        )}`}
                        className="text-slate-800 hover:underline"
                      >
                        {poster.phone_number}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-slate-600 font-medium min-w-fit">
                    Email:
                  </span>
                  <span className="text-slate-800 break-all text-sm">
                    {poster?.email_address ? (
                      <a
                        href={`mailto:${poster.email_address}`}
                        className="text-slate-800 hover:underline"
                      >
                        {poster.email_address}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
              </div>
            </div>

            {poster?.facebook ||
            poster?.instagram ||
            poster?.twitter ||
            poster?.tiktok ||
            poster?.linkedin ||
            poster?.pinterest ||
            poster?.youtube ? (
              <div className="space-y-3">
                <h3 className="text-sm font-semibold text-slate-600 uppercase tracking-wide">
                  Follow on Social
                </h3>
                <div className="grid grid-cols-2 gap-2">
                  {poster?.facebook && (
                    <a
                      href={poster.facebook}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#4267B2] hover:bg-[#365899] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiFacebook size={14} />
                      <span>Facebook</span>
                    </a>
                  )}
                  {poster?.linkedin && (
                    <a
                      href={poster.linkedin}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#0A66C2] hover:bg-[#094c91] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiLinkedin size={14} />
                      <span>LinkedIn</span>
                    </a>
                  )}
                  {poster?.instagram && (
                    <a
                      href={poster.instagram}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiInstagram size={14} />
                      <span>Instagram</span>
                    </a>
                  )}
                  {poster?.pinterest && (
                    <a
                      href={poster.pinterest}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#E60023] hover:bg-[#b8001b] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiPinterest size={14} />
                      <span>Pinterest</span>
                    </a>
                  )}
                  {poster?.twitter && (
                    <a
                      href={poster.twitter}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-black hover:bg-slate-800 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <span className="font-bold">𝕏</span>
                    </a>
                  )}
                  {poster?.tiktok && (
                    <a
                      href={poster.tiktok}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-black hover:bg-slate-800 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiTiktok size={14} />
                      <span>TikTok</span>
                    </a>
                  )}
                  {poster?.youtube && (
                    <a
                      href={poster.youtube}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#FF0000] hover:bg-[#d00000] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiYoutube size={14} />
                      <span>YouTube</span>
                    </a>
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 flex flex-col gap-6">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                {poster?.class_type === "Consumer" ? (
                  <h1 className="text-3xl font-bold text-slate-900">
                    {poster?.username}
                  </h1>
                ) : (
                  <h1 className="text-3xl font-bold text-slate-900">{`${poster?.legal_first_name} ${poster?.legal_last_name}`}</h1>
                )}
                <p className="text-base font-medium text-blue-600">
                  {Number(poster?.user_id) === 16 ||
                  poster?.email === "tonythebroker956@gmail.com"
                    ? "Broker / Owner of Glass Realty"
                    : poster?.class_type === "N/A" ||
                        poster?.class_type === "Consumer" ||
                        poster?.class_type === "Title Company"
                      ? ""
                      : poster?.class_type}
                </p>
                {poster?.class_type === "Title Company" && (
                  <>
                    <p className="text-base font-medium text-blue-600">
                      {poster?.business_name}
                    </p>
                    <p className="text-sm italic text-slate-600">
                      {poster?.position}
                    </p>
                  </>
                )}
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg font-bold text-slate-900">About</h2>
                </div>
                <div className="text-slate-700">
                  {poster?.about ||
                    "You have not set an about section for this user."}
                </div>
              </div>

              {allVideos.length > 0 && (
                <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 space-y-4">
                  <h2 className="text-lg font-bold text-slate-900">
                    Featured Videos ({allVideos.length})
                  </h2>
                  <div className="relative">
                    <div className="border border-slate-200 rounded-lg p-4 bg-slate-50">
                      <p className="text-xs font-semibold text-slate-500 mb-3 uppercase tracking-wide">
                        Video {allVideos[currentVideoIndex].number}
                      </p>
                      <div className="flex justify-center">
                        {renderVideoEmbed(allVideos[currentVideoIndex].url)}
                      </div>
                    </div>
                    {allVideos.length > 1 && (
                      <div className="flex items-center justify-between mt-4 gap-2">
                        <button
                          onClick={() =>
                            setCurrentVideoIndex(
                              currentVideoIndex === 0
                                ? allVideos.length - 1
                                : currentVideoIndex - 1,
                            )
                          }
                          className="p-2 bg-slate-200 hover:bg-slate-300 rounded-full transition-colors"
                          aria-label="Previous video"
                        >
                          <MdChevronLeft size={24} />
                        </button>
                        <div className="flex gap-2 justify-center flex-1">
                          {allVideos.map((_, idx) => (
                            <button
                              key={idx}
                              onClick={() => setCurrentVideoIndex(idx)}
                              className={`h-2 rounded-full transition-all ${
                                idx === currentVideoIndex
                                  ? "bg-slate-900 w-6"
                                  : "bg-slate-300 w-2 hover:bg-slate-400"
                              }`}
                              aria-label={`Go to video ${idx + 1}`}
                            />
                          ))}
                        </div>
                        <button
                          onClick={() =>
                            setCurrentVideoIndex(
                              currentVideoIndex === allVideos.length - 1
                                ? 0
                                : currentVideoIndex + 1,
                            )
                          }
                          className="p-2 bg-slate-200 hover:bg-slate-300 rounded-full transition-colors"
                          aria-label="Next video"
                        >
                          <MdChevronRight size={24} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-slate-900">
                    {poster?.legal_first_name || "User"}'s Active Properties
                  </h2>
                  <button
                    type="button"
                    className="text-sm font-semibold text-blue-600 hover:text-blue-700"
                    onClick={() => nav(`/user/${id}/active`)}
                  >
                    View all
                  </button>
                </div>

                {propertiesLoading ? (
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg text-sm text-slate-600">
                    Loading properties...
                  </div>
                ) : properties.length > 0 &&
                  properties.filter((p) => p.property_status === "Active")
                    .length > 0 ? (
                  <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    {properties
                      .filter((p) => p.property_status === "Active")
                      .map((property) => {
                        const previewImage = getPropertyImage(
                          property?.media_url,
                        );
                        const address =
                          [property?.street_number, property?.street_name]
                            .filter(Boolean)
                            .join(" ") ||
                          property?.title ||
                          "Untitled property";
                        const location = [property?.city, property?.state]
                          .filter(Boolean)
                          .join(", ");
                        const statusLabel =
                          property?.property_status || "Status";
                        return (
                          <div
                            key={property?.property_id || address}
                            className="border border-slate-200 rounded-xl overflow-hidden shadow-sm bg-white"
                          >
                            <div className="relative h-32 bg-slate-100">
                              {previewImage ? (
                                <img
                                  src={previewImage}
                                  alt={address}
                                  className="h-full w-full object-cover"
                                />
                              ) : (
                                <div className="flex h-full items-center justify-center text-slate-400 text-sm">
                                  No photo yet
                                </div>
                              )}
                              <span className="absolute top-2 left-2 px-2 py-1 text-xs font-semibold rounded-full bg-white/90 text-slate-800 border border-slate-200">
                                {statusLabel}
                              </span>
                            </div>
                            <div className="p-3 space-y-1">
                              <p className="text-sm font-semibold text-slate-900 truncate">
                                {address}
                              </p>
                              <p className="text-xs text-slate-500 truncate">
                                {location || "Location pending"}
                              </p>
                              <p className="text-sm font-bold text-blue-700">
                                {formatPrice(property?.price)}
                                {property?.for === "Lease" ? "/mo" : ""}
                              </p>
                              <div className="flex items-center justify-between text-xs text-slate-600">
                                <span>
                                  {property?.type || property?.for || "Type"}
                                </span>
                                <span>
                                  {property?.beds_total || 0} bd ·{" "}
                                  {property?.baths_full || 0} ba
                                </span>
                              </div>
                              <button
                                type="button"
                                className="w-full mt-2 bg-slate-900 text-white py-2 rounded-lg text-sm font-semibold hover:bg-slate-800 transition-colors"
                                onClick={() =>
                                  property?.property_id
                                    ? nav(`/property/${property.property_id}`)
                                    : null
                                }
                              >
                                View details
                              </button>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg text-sm text-slate-600">
                    Listings will appear here once they are available.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default User;
